import { Component } from "react"

class Birthday extends Component{
    private name = "誕生日"
    validate(callbackDialog,requireCheck){
        if(requireCheck && String(this.props).trim().length === 0){
            callbackDialog("エラー",this.name + "は必須です。")
            return false
        }
        if(requireCheck && String(this.props).trim().length > 0){
            if(!/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(String(this.props))){
                callbackDialog("エラー",this.name + "は「年-月-日」形式で入力してください。")
                return false
            }
        }
        return true
    }
}

export default Birthday;